import { render, staticRenderFns } from "./VirtualSelectiveMatches.vue?vue&type=template&id=46d1c0ef&"
import script from "./VirtualSelectiveMatches.vue?vue&type=script&lang=js&"
export * from "./VirtualSelectiveMatches.vue?vue&type=script&lang=js&"
import style0 from "./VirtualSelectiveMatches.vue?vue&type=style&index=0&id=46d1c0ef&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports